import { useCallback } from 'react';
import axios from 'axios';
import proxyApi from 'services/proxyApi';
import { BASE_URL, PROXY_API } from 'constants/proxyApi';

interface IpResponse {
  ip: string;
}

const { USER_TELEMETRY } = PROXY_API.GET;

const useFetchIpAddress = (isUserSignedIn: boolean) => {
  const fetchIpAddress = useCallback(async (userIp: string | null) => {
    try {
      if (userIp) return userIp;
      if (isUserSignedIn) {
        const { data } = await proxyApi.protectedRequest<IpResponse>({
          url: `${BASE_URL}/${USER_TELEMETRY.LOGIN_IP}`,
          method: 'GET',
        });
        return data.ip;
      }
      const { data } = await axios.get(`${BASE_URL}/${USER_TELEMETRY.IP}`);
      return data.ip;
    } catch (error) {
      return null;
    }
  }, [isUserSignedIn]);

  return fetchIpAddress;
};

export default useFetchIpAddress;
